import { render, staticRenderFns } from "./analisisRadiografico.vue?vue&type=template&id=5963f992&"
import script from "./analisisRadiografico.vue?vue&type=script&lang=js&"
export * from "./analisisRadiografico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports